module.exports = __webpack_public_path__ + "img/KinokoTable68.9b628ed3.jpg";